import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c990b0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100 card-body d-flex flex-row p-0 gap-5" }
const _hoisted_2 = { class: "w-12 px-10 pt-10" }
const _hoisted_3 = {
  key: 0,
  class: "card-body d-flex flex-column px-0 pt-0"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center pt-10 cursor-pointer" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "fs-1 fw-bolder" }, "Choose Your Plan")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_PlanColumnView = _resolveComponent("PlanColumnView")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.loadingDetails)
      ? (_openBlock(), _createBlock(_component_el_skeleton, { key: 0 }, {
          template: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_skeleton, {
                  variant: "text",
                  rows: 6,
                  animated: ""
                })
              ])
            ])
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.subscription)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_DataTable, {
                  "table-data": _ctx.table.items,
                  "table-header": _ctx.tableHeaders,
                  "enable-items-per-page-dropdown": true,
                  loading: _ctx.table.loading,
                  "rows-per-page": 10,
                  "row-class": "table-hover",
                  ref: "logsTable"
                }, {
                  "cell-created_at": _withCtx(({ row: item }) => [
                    _createTextVNode(_toDisplayString(item?.created_at), 1)
                  ]),
                  "cell-transaction": _withCtx(({ row: item }) => [
                    _createTextVNode(_toDisplayString(item?.transaction), 1)
                  ]),
                  "cell-remarks": _withCtx(({ row: item }) => [
                    _createTextVNode(_toDisplayString(item?.remarks), 1)
                  ]),
                  "cell-quantity": _withCtx(({ row: item }) => [
                    _createTextVNode(_toDisplayString(item?.quantity), 1)
                  ]),
                  "cell-description": _withCtx(({ row: item }) => [
                    _createTextVNode(_toDisplayString(item?.description), 1)
                  ]),
                  "cell-amount_total": _withCtx(({ row: item }) => [
                    _createTextVNode(_toDisplayString(item?.amount_total), 1)
                  ]),
                  "cell-amount_tax": _withCtx(({ row: item }) => [
                    _createTextVNode(_toDisplayString(item?.amount_tax), 1)
                  ]),
                  _: 1
                }, 8, ["table-data", "table-header", "loading"])
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_4,
                _createVNode(_component_PlanColumnView)
              ], 64))
        ], 64))
  ]))
}